// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 33 hooks for backend/offboarding.

import { useBackend } from '../useBackend'

/** POST /api/offboarding/addOffboardingDocument */
export function useAddOffboardingDocument<T = any>() {
  return useBackend<T>('offboarding/addOffboardingDocument')
}

/** POST /api/offboarding/addOffboardingNote */
export function useAddOffboardingNote<T = any>() {
  return useBackend<T>('offboarding/addOffboardingNote')
}

/** POST /api/offboarding/approveFinalPay */
export function useApproveFinalPay<T = any>() {
  return useBackend<T>('offboarding/approveFinalPay')
}

/** POST /api/offboarding/approveOffboarding */
export function useApproveOffboarding<T = any>() {
  return useBackend<T>('offboarding/approveOffboarding')
}

/** POST /api/offboarding/attachOffboardingInspection */
export function useAttachOffboardingInspection<T = any>() {
  return useBackend<T>('offboarding/attachOffboardingInspection')
}

/** POST /api/offboarding/cancelOffboarding */
export function useCancelOffboarding<T = any>() {
  return useBackend<T>('offboarding/cancelOffboarding')
}

/** POST /api/offboarding/getCertificateOfService */
export function useGetCertificateOfService<T = any>() {
  return useBackend<T>('offboarding/getCertificateOfService')
}

/** POST /api/offboarding/getDriverOffboarding */
export function useGetDriverOffboarding<T = any>() {
  return useBackend<T>('offboarding/getDriverOffboarding')
}

/** POST /api/offboarding/getExitReport */
export function useGetExitReport<T = any>() {
  return useBackend<T>('offboarding/getExitReport')
}

/** POST /api/offboarding/getFinalPayPreview */
export function useGetFinalPayPreview<T = any>() {
  return useBackend<T>('offboarding/getFinalPayPreview')
}

/** POST /api/offboarding/getOffboardingAccess */
export function useGetOffboardingAccess<T = any>() {
  return useBackend<T>('offboarding/getOffboardingAccess')
}

/** POST /api/offboarding/getOffboardingCase */
export function useGetOffboardingCase<T = any>() {
  return useBackend<T>('offboarding/getOffboardingCase')
}

/** POST /api/offboarding/getOffboardingCases */
export function useGetOffboardingCases<T = any>() {
  return useBackend<T>('offboarding/getOffboardingCases')
}

/** POST /api/offboarding/getOffboardingEvidence */
export function useGetOffboardingEvidence<T = any>() {
  return useBackend<T>('offboarding/getOffboardingEvidence')
}

/** POST /api/offboarding/getOffboardingLetter */
export function useGetOffboardingLetter<T = any>() {
  return useBackend<T>('offboarding/getOffboardingLetter')
}

/** POST /api/offboarding/getOffboardingStepCheck */
export function useGetOffboardingStepCheck<T = any>() {
  return useBackend<T>('offboarding/getOffboardingStepCheck')
}

/** POST /api/offboarding/getOffboardingUi19 */
export function useGetOffboardingUi19<T = any>() {
  return useBackend<T>('offboarding/getOffboardingUi19')
}

/** POST /api/offboarding/openOffboarding */
export function useOpenOffboarding<T = any>() {
  return useBackend<T>('offboarding/openOffboarding')
}

/** POST /api/offboarding/openOffboardingFile */
export function useOpenOffboardingFile<T = any>() {
  return useBackend<T>('offboarding/openOffboardingFile')
}

/** POST /api/offboarding/openUi19 */
export function useOpenUi19<T = any>() {
  return useBackend<T>('offboarding/openUi19')
}

/** POST /api/offboarding/prepareFinalPay */
export function usePrepareFinalPay<T = any>() {
  return useBackend<T>('offboarding/prepareFinalPay')
}

/** POST /api/offboarding/prepareUi19 */
export function usePrepareUi19<T = any>() {
  return useBackend<T>('offboarding/prepareUi19')
}

/** POST /api/offboarding/readOffboardingLeave */
export function useReadOffboardingLeave<T = any>() {
  return useBackend<T>('offboarding/readOffboardingLeave')
}

/** POST /api/offboarding/recordEmploymentState */
export function useRecordEmploymentState<T = any>() {
  return useBackend<T>('offboarding/recordEmploymentState')
}

/** POST /api/offboarding/recordExitInterview */
export function useRecordExitInterview<T = any>() {
  return useBackend<T>('offboarding/recordExitInterview')
}

/** POST /api/offboarding/recordFinalPayPaidOnSimplePay */
export function useRecordFinalPayPaidOnSimplePay<T = any>() {
  return useBackend<T>('offboarding/recordFinalPayPaidOnSimplePay')
}

/** POST /api/offboarding/relayFinalPay */
export function useRelayFinalPay<T = any>() {
  return useBackend<T>('offboarding/relayFinalPay')
}

/** POST /api/offboarding/sendOffboardingLetter */
export function useSendOffboardingLetter<T = any>() {
  return useBackend<T>('offboarding/sendOffboardingLetter')
}

/** POST /api/offboarding/sendUi19 */
export function useSendUi19<T = any>() {
  return useBackend<T>('offboarding/sendUi19')
}

/** POST /api/offboarding/signOffOffboarding */
export function useSignOffOffboarding<T = any>() {
  return useBackend<T>('offboarding/signOffOffboarding')
}

/** POST /api/offboarding/signOffboardingUpload */
export function useSignOffboardingUpload<T = any>() {
  return useBackend<T>('offboarding/signOffboardingUpload')
}

/** POST /api/offboarding/updateOffboardingCase */
export function useUpdateOffboardingCase<T = any>() {
  return useBackend<T>('offboarding/updateOffboardingCase')
}

/** POST /api/offboarding/updateOffboardingItem */
export function useUpdateOffboardingItem<T = any>() {
  return useBackend<T>('offboarding/updateOffboardingItem')
}
